import React, { PureComponent } from 'react';

import { Container } from '@lglp/components';
import PropTypes from 'prop-types';

class OutboundLink extends PureComponent {
  static propTypes = {
    to: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  };

  render() {
    const { to, children, ...rest } = this.props;

    return (
      <Container as="a" href={to} rel="noopener noreferrer" {...rest}>
        {children}
      </Container>
    );
  }
}

export default OutboundLink;
